module.exports = __webpack_public_path__ + "img/Front End.dfeaf014.png";